import { Image, Text, View } from '@react-pdf/renderer'
import PDFPage from '@/components/ReportPDF/PDFPage'
import PDFParagraph from '@/components/ReportPDF/PDFParagraph'
import React from 'react'

const Chapter4Sub1Page = ({ chartImg1, setPage, reportData }) => (
  <PDFPage hideTitleDivider reportData={reportData}>
    <Text
      render={({ pageNumber }) => {
        setPage({ chap4_1: pageNumber })
      }}
    />
    <View>
      <PDFParagraph>
        {'    '}
        <Text>
          依受測者釣中行為進行「瀏覽郵件」、「點閱連結」、「開啟附件」與「輸入資料」等多重釣中行為進行統計，並以各類行為之釣中人數比例繪製下列圓環圖
          ：
        </Text>
      </PDFParagraph>

      {chartImg1 && <Image src={chartImg1} />}
    </View>
  </PDFPage>
)

export default Chapter4Sub1Page
